import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';
import { EventlinkInterface, EventlinkInterfaceAPI } from '../model/eventlink';
import { EventsInterfaceAPI } from '../model/sms-events';
import { SPIInterfaceAPI } from '../model/sms-spi';
import { SPSInterfaceAPI } from '../model/sms-sps';
import { TempsInterfaceAPI } from '../model/sms-templates';
import { mbeConfigService } from './mbe-config.service';

@Injectable({
  providedIn: 'root'
})
export class EventlinksService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllEventLinks(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<EventlinkInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<any>(`${this.URL}/eli/getalleventlinks/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers}).pipe(
      map((res) => {
        const rawItems = res?.items ?? res?.eventLinkList ?? [];
        const items = rawItems.map((it: any) => ({
          id: it?.id != null ? Number(it.id) : undefined,
          ELIGid: it?.ELIGid != null ? Number(it.ELIGid) : undefined,
          frontEndUserName: it?.frontEndUserName ?? it?.frontEndUserName ?? '',
          recordDate: it?.recordDate,
          recordTime: it?.recordTime,
          relOEventID: it?.relOEventID != null ? Number(it.relOEventID) : undefined,
          relOSPIID: it?.relOSPIID != null ? Number(it.relOSPIID) : undefined,
          relOSPSID: it?.relOSPSID != null ? Number(it.relOSPSID) : undefined,
          relOTEPID: it?.relOTEPID != null ? Number(it.relOTEPID) : undefined,
          sendToArchive: it?.sendToArchive,
          sendToArchiveDate: it?.sendToArchiveDate,
          USEID: it?.USEID != null ? Number(it.USEID) : undefined,
          UACID: it?.UACID != null ? Number(it.UACID) : undefined
        }));
        const total_count = res?.total_count ?? res?.totalCount ?? items.length;
        return { items, total_count } as EventlinkInterfaceAPI;
      }),
      catchError(this.handleError));
  }

  getEventLinks(id: number): Observable<EventlinkInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<any>(`${this.URL}/eli/geteventlink/${id}`, {headers}).pipe(
      map((it: any) => ({
        id: it?.id != null ? Number(it.id) : undefined,
        ELIGid: it?.ELIGid != null ? Number(it.ELIGid) : undefined,
        frontEndUserName: it?.frontEndUserName ?? '',
        recordDate: it?.recordDate,
        recordTime: it?.recordTime,
        relOEventID: it?.relOEventID != null ? Number(it.relOEventID) : (it?.relOEventId != null ? Number(it.relOEventId) : undefined),
        relOSPIID: it?.relOSPIID != null ? Number(it.relOSPIID) : (it?.relOSpiId != null ? Number(it.relOSpiId) : undefined),
        relOSPSID: it?.relOSPSID != null ? Number(it.relOSPSID) : (it?.relOSpsId != null ? Number(it.relOSpsId) : undefined),
        relOTEPID: it?.relOTEPID != null ? Number(it.relOTEPID) : (it?.relOTepId != null ? Number(it.relOTepId) : undefined),
        sendToArchive: it?.sendToArchive,
        sendToArchiveDate: it?.sendToArchiveDate,
        USEID: it?.USEID != null ? Number(it.USEID) : undefined,
        UACID: it?.UACID != null ? Number(it.UACID) : undefined
      } as EventlinkInterface)),
      catchError(this.handleError));
  }

  updateELI(eli: EventlinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update eli: ' + JSON.stringify(eli));
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/updateeventlink`, eli, {headers}).pipe(catchError(this.handleError));
  }

  createELI(eli: EventlinkInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Create eli: ' + JSON.stringify(eli));
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/createeventlink`, eli, {headers}).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getAllEvents(): Observable<EventsInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(`${this.URL}/eli/getallevents`, {headers}).pipe(
      map((res) => {
        const rawItems = res?.items ?? [];
        const items = rawItems.map((it: any) => ({
          id: it?.id != null ? Number(it.id) : undefined,
          description: it?.description ?? ''
        }));
        const total_count = res?.total_count ?? res?.totalCount ?? items.length;
        return { items, total_count } as EventsInterfaceAPI;
      }),
      catchError(this.handleError));
  }

  getAllSPI(): Observable<SPIInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(`${this.URL}/eli/getallspi`, {headers}).pipe(
      map((res) => {
        const rawItems = res?.items ?? [];
        const items = rawItems.map((it: any) => ({
          id: it?.id != null ? Number(it.id) : undefined,
          servicePointName: it?.servicePointName ?? '',
          globalID: it?.globalID ?? it?.globalId ?? ''
        }));
        const total_count = res?.total_count ?? res?.totalCount ?? items.length;
        return { items, total_count } as SPIInterfaceAPI;
      }),
      catchError(this.handleError));
  }

  getAllSPS(): Observable<SPSInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(`${this.URL}/eli/getallsps`, { headers }).pipe(
      map((res) => {
        const rawItems = res?.spsList ?? res?.items ?? [];
        const items = rawItems.map((it: any) => ({
          id: it?.id != null ? Number(it.id) : undefined,
          servicePointName: it?.servicePointName ?? it?.spsName ?? ''
        }));
        const total_count = res?.totalCount ?? res?.total_count ?? items.length;
        return { items, total_count } as SPSInterfaceAPI;
      }),
        catchError(this.handleError));
  }

  // Normalize template list + coerce ids so edit dropdown indexOf/findIndex matches 27/10/2026 DW
  getAllTemplates(): Observable<TempsInterfaceAPI> {
    const headers = this.headers;
    return this.httpClient.get<any>(`${this.URL}/eli/getalltemplates`, {headers}).pipe(
      map((res) => {
        const rawItems = res?.items ?? res?.templateList ?? [];
        const items = rawItems.map((it: any) => ({
          id: it?.id != null ? Number(it.id) : undefined,
          name: it?.name ?? ''
        }));
        const total_count = res?.total_count ?? res?.totalCount ?? items.length;
        return { items, total_count } as TempsInterfaceAPI;
      }),
      catchError(this.handleError));
  }

  
  //added call to set status                                            22/11/23 CN
  setEventLinkStatus(id: {id: number}): Observable<BasicResponse> {
    console.log("======================================================================");
    console.log(id.id);
    console.log("======================================================================");
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/eli/seteventlinkstatus/${id.id}`, {headers}).pipe(catchError(this.handleError));
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: getallsps API returns spsList not items; Service Point Setup Name column empty. What changed: getAllSPS() now maps the raw API response to SPSInterfaceAPI: uses res?.spsList ?? res?.items for items array, res?.totalCount ?? res?.total_count for total_count. Previous behavior: API returns { spsList: [...], totalCount: N }; consumers expected { items: [...] }; sps.items was undefined so SPS lookup arrays stayed empty. New behavior: Service normalizes response so consumers always receive { items, total_count } regardless of API structure. Reason: Service Point Setup Name column not populating; API returns spsList. Impact: All consumers of getAllSPS() get consistent interface; Event Link table Service Point Setup Name column populates. - 2026-02-02 - HE
// C002: API may return spsName instead of servicePointName. What changed: Each item in getAllSPS map now normalizes to { id, servicePointName: it?.servicePointName ?? it?.spsName ?? '' }. Impact: SPS names display regardless of API property naming. - 2026-02-02 - HE
// C003: Event link table and edit not mapping API data correctly. What changed: (1) getAllEventLinks() now normalizes response to { items, total_count }; maps each item to coerce id, ELIGid, relOEventID, relOSPSID, relOTEPID, UACID to numbers so table lookups and edit form work; supports alternative keys (eventLinkList, totalCount). (2) getEventLinks(id) normalizes single record and coerces IDs plus camelCase (relOEventId, relOSpsId, relOTepId). (3) getAllEvents() and getAllSPI() now return { items, total_count } with id coerced to number so Event/SPI dropdowns and table columns resolve correctly. (4) getAllSPS() item id coerced to number. Previous behavior: Raw API returns string IDs and possibly different keys; table Event/SPS/Template columns and edit dropdowns could fail to match. New behavior: All ELI APIs return consistent shape and numeric IDs; table displays Event Name, Service Point Setup Name, Template Name; edit form populates and submits correct IDs. Reason: User requirement to map and display getallevents, getallspi, getallsps, getalleventlinks data correctly. Impact: Event link table and edit view work with UAT API response shape. - 2026-02-24 - HE
// C004: getAllTemplates() now normalizes items/templateList and coerces id to number (same pattern as events/SPS). Reason: Edit Template dropdown failed Number vs string index match. Impact: Template dropdown selection resolves on edit load. - 2026-10-27 - DW
